'use strict';

var React = require('react'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    { PropTypes } = React;

require('./Container.less');

var Container = React.createClass({
  mixins: [PureRenderMixin, ClassNameMixin],

  propTypes: {
    color: PropTypes.oneOf(['dark', 'light']),
    style: PropTypes.object
  },

  getCSSModifiers() {
    return [
      this.props.color,
      this.props.fillParent && 'fillParent'
    ];
  },

  getDefaultProps() {
    return {
      color: 'dark',
      fillParent: true
    };
  },

  className: 'Container',

  render() {
    return (
      <div className={this.getClassName()}
           style={this.props.style}>
        {this.props.children}
      </div>
    );
  },

});

module.exports = Container;



/** WEBPACK FOOTER **
 ** ./organisms/Container.jsx
 **/